export const CONTENT_GATEWAY_BASE_URL = 'https://content.casumocdn.com';

export const PAYLOAD_IMGIX_URL = 'https://images-p.casumo.com/media';

export const API_URL_TEST = 'https://www.casumotest.com';
export const API_URL_PROD = 'https://www.casumo.com';

export const IS_BROWSER = import.meta.env.MODE !== 'server';

export const WEB_COMPONENT_TYPES: Record<string, string> = {
    CURATED_CARD: 'curated-card',
} as const;

export const MARKETS = {
    ___en: '___en',
    ca_en: 'ca_en',
    fi_fi: 'fi_fi',
    gb_en: 'gb_en',
    in_en: 'in_en',
    no_no: 'no_no',
    on_en: 'on_en',
    se_sv: 'se_sv',
    es_es: 'es_es',
    nz_en: 'nz_en',
    jp_ja: 'jp_ja',
    ie_en: 'ie_en',
    gi_en: 'gi_en',
} as const;

export const CURRENCIES = {
    EUR: 'EUR',
    GBP: 'GBP',
    DKK: 'DKK',
    NOK: 'NOK',
    SEK: 'SEK',
    CAD: 'CAD',
    NZD: 'NZD',
    INR: 'INR',
    USD: 'USD',
    JPY: 'JPY',
} as const;

export const MARKET_CURRENCIES: Record<string, string> = {
    [MARKETS.___en]: CURRENCIES.EUR,
    [MARKETS.ca_en]: CURRENCIES.CAD,
    [MARKETS.fi_fi]: CURRENCIES.EUR,
    [MARKETS.gb_en]: CURRENCIES.GBP,
    [MARKETS.in_en]: CURRENCIES.INR,
    [MARKETS.no_no]: CURRENCIES.NOK,
    [MARKETS.on_en]: CURRENCIES.CAD,
    [MARKETS.se_sv]: CURRENCIES.SEK,
    [MARKETS.es_es]: CURRENCIES.EUR,
    [MARKETS.nz_en]: CURRENCIES.NZD,
    [MARKETS.jp_ja]: CURRENCIES.JPY,
    [MARKETS.ie_en]: CURRENCIES.EUR,
    [MARKETS.gi_en]: CURRENCIES.GBP,
} as const;

export const URL_PREFIXES = {
    [MARKETS.___en]: 'en',
    [MARKETS.ca_en]: 'en-ca',
    [MARKETS.fi_fi]: 'fi',
    [MARKETS.gb_en]: 'en-gb',
    [MARKETS.in_en]: 'en-in',
    [MARKETS.no_no]: 'no',
    [MARKETS.on_en]: 'on',
    [MARKETS.se_sv]: 'sv',
    [MARKETS.es_es]: 'es',
    [MARKETS.nz_en]: 'en-nz',
    [MARKETS.jp_ja]: 'ja',
    [MARKETS.ie_en]: 'ie',
    [MARKETS.gi_en]: 'gi',
} as const;

export const LOCALE_CODES = {
    row: 'en-ROW',
    en: 'en',
    'en-ca': 'en-CA',
    on: 'en-ON',
    no: 'nb-NO',
    de: 'de-DE',
    fi: 'fi-FI',
    'en-gb': 'en-GB',
    'en-in': 'en-IN',
    sv: 'sv-SE',
    es: 'es-ES',
    'en-nz': 'en-NZ',
    ja: 'ja-JP',
    ie: 'en-IE',
    gi: 'en-GI',
    rog: 'en-ROG',
} as const;

export const LOCALE_TO_MARKET = {
    en: MARKETS.___en,
    'en-ca': MARKETS.ca_en,
    on: MARKETS.on_en,
    no: MARKETS.no_no,
    fi: MARKETS.fi_fi,
    'en-gb': MARKETS.gb_en,
    'en-in': MARKETS.in_en,
    sv: MARKETS.se_sv,
    es: MARKETS.es_es,
    'en-nz': MARKETS.nz_en,
    ja: MARKETS.jp_ja,
    ie: MARKETS.ie_en,
    gi: MARKETS.gi_en,
    row: MARKETS.___en,
    rog: MARKETS.___en,
};

export const GATEKEEPER_LOCALE_TO_MARKET = {
    [LOCALE_CODES.en]: MARKETS.___en,
    [LOCALE_CODES['en-ca']]: MARKETS.ca_en,
    [LOCALE_CODES.on]: MARKETS.on_en,
    [LOCALE_CODES.no]: MARKETS.no_no,
    [LOCALE_CODES.fi]: MARKETS.fi_fi,
    [LOCALE_CODES['en-gb']]: MARKETS.gb_en,
    [LOCALE_CODES['en-in']]: MARKETS.in_en,
    [LOCALE_CODES.sv]: MARKETS.se_sv,
    [LOCALE_CODES.es]: MARKETS.es_es,
    [LOCALE_CODES['en-nz']]: MARKETS.nz_en,
    [LOCALE_CODES.ja]: MARKETS.jp_ja,
    [LOCALE_CODES.ie]: MARKETS.ie_en,
    [LOCALE_CODES.gi]: MARKETS.gi_en,
    [LOCALE_CODES.row]: MARKETS.___en,
    [LOCALE_CODES.rog]: MARKETS.___en,
};

export const FALLBACK_EN_LOCALE = LOCALE_CODES.en;

export const DEVICES = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    UNKNOWN: 'unknown',
};

export const ROUTES_IDS = {
    PROMOTION_DETAILS: 'PROMOTION_DETAILS',
    PROMOTIONS: 'PROMOTIONS',
    TOP_LISTS: 'TOP_LISTS',
    REGISTER: '/register',
    LOGIN: '/log-in',
    PLAY: '/play/:gameSlug',
    PRACTICE: 'PRACTICE',
} as const;

// Intended to replace marketSlug
export const SYSTEM_MARKET_SLUGS = {
    EN: '___en',
    GB: 'gb_en',
    CA: 'ca_en',
    NZ: 'nz_en',
    IN: 'in_en',
    ES: 'es_es',
    ON: 'on_en',
    FI: 'fi_fi',
    SE: 'se_sv',
    IE: 'ie_en',
    GI: 'gi_en',
    NO: 'no_no',
} as const;

export const COUNTRIES = {
    CA: 'ca',
} as const;

export const REGIONS = {
    ON: 'ontario',
};
